/**
 * 获取子元素的 JSON 格式数据
 * @param $elem DOM 节点
 */
function getChildrenJSON($elem) {
  const result = []; // 存储结果

  const $children = $elem.childNodes || []; // 注意 childNodes() 可以获取文本节点
  $children.forEach((item, index) => {
    if (item.nodeType === 3) {
      result[index] = item.nodeValue;
    } else if (item.nodeType === 1) {
      const cur = {
        tag: item.tagName.toLowerCase(),
        attrs: Object.keys(item.attributes).map(key => ({
          name: item.attributes[key].nodeName,
          value: item.attributes[key].nodeValue,
        })),
        children: item.childNodes && item.childNodes.length > 0 ? getChildrenJSON(item) : [],
      };
      result[index] = cur;
    }
  });
  return result;
}

export default getChildrenJSON;
